import React from 'react';
function Dashboard(_ref) {
  let {
    color = '#788590',
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.926 4.946c3.05-3.05 7.581-3.713 11.278-1.994l-1.387 1.261c-2.935-1.06-6.349-.422-8.697 1.926-3.238 3.237-3.238 8.504 0 11.741 3.237 3.238 8.504 3.238 11.74 0 2.35-2.348 2.986-5.763 1.927-8.697l1.26-1.387c1.72 3.697 1.058 8.227-1.993 11.278-3.901 3.901-10.227 3.901-14.128 0-3.901-3.902-3.901-10.227 0-14.128zm13.547-.452c.274-.208.68-.151.933.102.263.263.304.684.079.965a3.61 3.61 0 01-.11.122L14.347 11.4a2.53 2.53 0 01-4.226 2.478A2.532 2.532 0 0112.6 9.653L18.3 4.649s.127-.12.173-.155z",
    fill: color,
    fillRule: "evenodd"
  }));
}
export default Dashboard;